// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from "vue";
import App from "./App";
import router from "./router";
import Notifications from "vue-notification";
import VueQuillEditor from "vue-quill-editor";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import "./assets/css/custom.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "@mdi/font/css/materialdesignicons.css";
Vue.use(Notifications);
Vue.use(VueQuillEditor);
Vue.use(Vuelidate);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  vuetify,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js